import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/_home": [6],
		"/aa-offer": [7],
		"/app-choice": [8],
		"/assessment-purchase": [9],
		"/cancel-subscription": [10,[2]],
		"/cancel-subscription/assessment-center": [11,[2]],
		"/cancel-subscription/cancel-feedback": [12,[2]],
		"/cancel-subscription/confirmation": [13,[2]],
		"/cancel-subscription/pause": [14,[2]],
		"/cancel-subscription/pause/manage": [15,[2]],
		"/cancel-subscription/pause/success": [16,[2]],
		"/cancel-subscription/save-offer": [17,[2]],
		"/cancel-subscription/success": [18,[2]],
		"/claimed-offer": [19],
		"/classic": [20],
		"/create-account": [21],
		"/create-account/offer/[offer_hash]": [22],
		"/debug/experiment-assign": [23],
		"/desktop-choice": [24],
		"/download-app": [25],
		"/email-preferences": [26],
		"/expired": [27],
		"/forgot-password": [28],
		"/get-started": [29],
		"/giveaway/family-vacation-2026": [30],
		"/inbound-gateway": [31],
		"/inside-pw": [32],
		"/link-entry": [33],
		"/login-account-selection": [36],
		"/login-expired-link": [37],
		"/login-redeemed-link": [38],
		"/login-same-device-success": [39],
		"/login-secondary-device-success": [40],
		"/login": [34,[3]],
		"/login/too-many-attempts": [35,[3]],
		"/logout": [41],
		"/magic-link-pending": [42],
		"/paddle": [43],
		"/parent-section": [44,[4]],
		"/parent-section/assessment-center": [45,[4]],
		"/parent-section/membership": [46,[4]],
		"/parent-section/membership/billing": [47,[4]],
		"/parent-section/membership/payment": [48,[4]],
		"/password-reset-success": [50],
		"/password-reset": [49],
		"/premium": [51],
		"/printables": [52],
		"/prospect-register": [53],
		"/purchase-gift": [54],
		"/qr-entry": [55],
		"/reactivation": [56],
		"/redeem": [57],
		"/reset-link-expired": [58],
		"/starter-pack": [59],
		"/subscription-consume": [62],
		"/subscription": [60],
		"/subscription/offer/[offer_hash]": [61],
		"/support-chatbot": [63],
		"/terminate": [64],
		"/tutor-offer": [65],
		"/universal/magic-link-redeem": [66],
		"/unsupported-browser": [67],
		"/upgrade": [68]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';